import "./index.es44.js";
import e from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import i from "react";
import "./index.es50.js";
import "./index.es51.js";
import m from "./index.es76.js";
const y = ({
  sheetData: t,
  fileName: r
}) => {
  const o = () => {
    m(t, { fileName: r });
  };
  return /* @__PURE__ */ i.createElement(e, { isSmall: !0, styleType: "primary", onClick: o }, "Last ned data");
};
export {
  y as default
};
//# sourceMappingURL=index.es85.js.map
